 import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { IProposal } from "../../../types/models/proposal.modals";

 interface IResponse {
  proposal: IProposal;
}

 export function useGetProposalByIdUnauthenticatedHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/campaigns/proposals/id",
  });
}
